const React = require('react')
const { inject } = require('@vercel/analytics')

inject()

export function wrapPageElement({ element, props }) {
  const Layout = element.type.Layout ?? React.Fragment

  return <Layout {...props}>{element}</Layout>
}
